export default function insertDataToForm() {
  const contentElement = document.querySelector(".insert-to-form");

  if (contentElement) {
    // Get all the div elements within the content element
    const divs = contentElement.querySelectorAll("div.insert-to-form-data");

    // Extract and format the content
    let content = "";
    divs.forEach((div) => {
      // Check if the current div has the 'insert-to-form-data-extraspace' class
      if (div.classList.contains("insert-to-form-data-extraspace")) {
        content += "\n"; // Add an extra empty line before this div
      }

      // Get the direct text content of the div
      let divText = div.childNodes[0]
        ? div.childNodes[0].textContent.trim()
        : "";

      // Get the text content of any spans within the div
      let spanText = Array.from(div.querySelectorAll("span"))
        .map((span) => span.textContent.trim())
        .filter((text) => text.length > 0) // Filter out empty text
        .join(" ");

      // Combine the div text and span text
      let combinedText = `${divText} ${spanText}`.trim();

      // Append the combined text to the content with a newline if it's not empty
      if (combinedText) {
        content += combinedText + "\n";
      }
    });

    // Find the target textarea field in Gravity Form
    const targetField = document.querySelector(".dynamic-offer-info textarea");

    if (targetField) {
      // Set the formatted content as the value of the textarea
      targetField.value = content.trim();
    }
  }
}
